import React, { useState, useEffect, useRef } from "react";
import { apiBaseUrl } from "../../config";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from 'swiper/modules';
import "swiper/css";
import 'swiper/css/navigation';

const Carousel = ({ userId }) => {
    const [banners, setBanners] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const hasFetched = useRef(false);
    const intervalRef = useRef(null);
    const navigate = useNavigate();

    const fetchBanners = async () => {
        try {
            const response = await fetch(`${apiBaseUrl}user/get-all-seller-banner/${userId}`);
            const data = await response.json();

            if (response.ok && data.success && data.data?.[0]?.banners) {
                setBanners(data.data[0].banners);
            } else {
                setError("No banners found");
            }
        } catch (err) {
            setError("Error fetching banners");
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

   const handleCategoryClick = (index) => {
    try {
        let link = banners[index]?.link;
        if (link) {
            // Add https:// if it's missing
            if (!/^https?:\/\//i.test(link)) {
                link = `https://${link}`;
            }
            window.open(link, "_blank"); // or window.location.href = link;
        } else {
            console.warn("No link found for banner at index", index);
        }
    } catch (error) {
        console.error("Error navigating to banner link:", error);
    }
};




    useEffect(() => {
        if (!hasFetched.current && userId) {
            hasFetched.current = true;
            fetchBanners();
        }
    }, [userId]);

    useEffect(() => {
        if (banners.length > 1) {
            clearInterval(intervalRef.current);
            intervalRef.current = setInterval(() => {
                setCurrentIndex((prev) => (prev + 1) % banners.length);
            }, 3000);
        }
        return () => clearInterval(intervalRef.current);
    }, [banners]);

    const nextImage = () => {
        setCurrentIndex((prev) => (prev + 1) % banners.length);
    };

    const prevImage = () => {
        setCurrentIndex((prev) => (prev === 0 ? banners.length - 1 : prev - 1));
    };

    if (loading) return <p>Loading...</p>;
    if (error) return <p className="text-red-500">{error}</p>;
    if (banners.length === 0) return <p>No banners available</p>;

    const defaultImageUrl = process.env.REACT_APP_S3_URL || "https://via.placeholder.com/800x400";

    return (
        <div className="image-slider">
<Swiper className="mySwiper slider " navigation={true} loop={true}  autoplay={{
    delay: 3000,
    disableOnInteraction: false,
  }} modules={[Navigation,Autoplay]}>
            {banners.map((banner, index) => {
                const url = banner.banner_image || "";
                const isS3Url = url.includes("https://hello-image-bucket.s3");
                const imageUrl = isS3Url ? url : defaultImageUrl + url;

                return (
                    <>
                    
        <SwiperSlide key={index}><div className="sliderBox">
            <figure><img width="100%" src={imageUrl} className="img-fluid rounded-4" alt={banner.title || "Banner"} /></figure><figcaption className="banner-title">{banner.title}</figcaption></div></SwiperSlide>
      
                    {/* <div
                        key={index}
                        className={`slider-image ${index === currentIndex ? "slide-in" : ""}`}
                        style={{
                            display: index === currentIndex ? "block" : "none",
                            zIndex: index === currentIndex ? 2 : 1,
                            cursor: "pointer",
                        }}
                        onClick={() => handleCategoryClick(index)}
                    >
                        <img
                            src={imageUrl}
                            className="img-fluid rounded-4"
                            alt={banner.title || "Banner"}
                        />
                        <div className="banner-title">{banner.title}</div>
                    </div> */}
                    </>
                );
            })}
</Swiper>
            {/* <div className="carousel-controls">
                <button onClick={prevImage}>Previous</button>
                <button onClick={nextImage}>Next</button>
            </div> */}
        </div>
    );
};

export default Carousel;

